import { Injectable, signal } from "@angular/core";
import { IngestionFieldDefinition } from "../../data-ingestion/data.ingestion.service";

@Injectable()
export class WorkflowFormContext {
    readonly formFields = signal<IngestionFieldDefinition[]>([]);
}
